import { RequestError } from '../requestError';
import api from '../axiosBase';
import { getURL } from '../serviceHelper';
import { getEnv } from '../../AppConfigs';

const SPSiteId = getEnv('REACT_APP_SP_SITE_ID');
const SPListId = getEnv('REACT_APP_DOCUMENT_PERMISSION_DEFAULT_USER_ID_LIST_ID');


const expand = '&expand=fields(select=id,StatusId, title, UserId)';

export class DefaultUserIdService {
  static async getUserIdByStatus(statusId?: any) {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&filter=fields/StatusId eq ${statusId}`))
        .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

  static async updateUserIdByStatus(statusId: any, fields: any) {
    return api.patch(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${statusId}/fields`), fields)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }
}